import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BookDemo from "./components/BookDemo";

import Ho from "./pages/Ho";
import MethodologyPage from "./pages/MethodologyPage";
import AboutPage from "./pages/AboutPage";
import BlogsPage from "./pages/BlogsPage";
import BlogPost from "./pages/BlogPost";
import ContactUs from "./pages/ContactUs";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import SyllabusPage from "./pages/SyllabusPage";
import Disclaimer from "./pages/Disclaimer";

import ExplorePage from "./pages/ExplorePage";
import CategoryPage from "./pages/CategoryPage";

import CareerGuidance from "./pages/CareerGuidance";
import PlacementGuidance from "./pages/PlacementTraining";
import HireTalent from "./pages/HireTalent";

import GenAIOverview from "./pages/GenAIOverview";
import CloudOverview from "./pages/CloudOverview";
import DataAnalyticsOverview from "./pages/DataAnalyticsOverview";
import PowerBIOverview from "./pages/PowerBIOverview";
import AIEngineerOverview from "./pages/AIEngineerOverview";
import AgenticAIOverview from "./pages/AgenticAIOverview";   // ✅ ADDED

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

/* 🔐 ADMIN IMPORTS */
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedAdmin from "./admin/ProtectedAdmin";

import useRevealOnScroll from "./utils/useRevealOnScroll";
import ScrollToTop from "./utils/ScrollToTop";
import GlobalMarquee from "./components/GlobalMarquee";

import "./styles/global.css";

/* 👇 Layout Controller (Hide Navbar/Footer on Admin Pages) */
function LayoutWrapper({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Navbar />}
      {!isAdmin && <GlobalMarquee />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  useRevealOnScroll();

  useEffect(() => {
    const cursor = document.createElement("div");
    cursor.className = "custom-cursor";
    document.body.appendChild(cursor);

    const moveCursor = (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      cursor.remove();
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />

      <LayoutWrapper>
        <Routes>

          {/* ===================== */}
          {/* 🔐 ADMIN ROUTES */}
          {/* ===================== */}

          <Route path="/admin" element={<AdminLogin />} />

          <Route
            path="/admin/dashboard"
            element={
              <ProtectedAdmin>
                <AdminDashboard />
              </ProtectedAdmin>
            }
          />

          {/* ===================== */}
          {/* 🌐 MAIN WEBSITE ROUTES */}
          {/* ===================== */}

          <Route path="/" element={<Ho />} />

          <Route path="/explore/:topic" element={<ExplorePage />} />
          <Route path="/category/:item" element={<CategoryPage />} />

          <Route path="/methodology" element={<MethodologyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:id" element={<BlogPost />} />

          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetail />} />

          <Route path="/syllabus" element={<SyllabusPage />} />
          <Route path="/syllabus/:category" element={<SyllabusPage />} />
          <Route path="/syllabus/:category/:sub" element={<SyllabusPage />} />

          <Route path="/career-guidance" element={<CareerGuidance />} />
          <Route path="/placement-guidance" element={<PlacementGuidance />} />
          <Route path="/hire-talent" element={<HireTalent />} />

          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

          <Route path="/book-demo" element={<BookDemo />} />

          {/* ===================== */}
          {/* 🚀 JOB READINESS PROGRAMS */}
          {/* ===================== */}

          <Route
            path="/job-readiness/gen-ai-starter"
            element={<GenAIOverview />}
          />

          <Route
            path="/job-readiness/cloud-computing-starter"
            element={<CloudOverview />}
          />

          <Route
            path="/job-readiness/data-analysis-starter"
            element={<DataAnalyticsOverview />}
          />

          <Route
            path="/job-readiness/power-bi-data-analyst"
            element={<PowerBIOverview />}
          />

          <Route
            path="/job-readiness/ai-engineer"
            element={<AIEngineerOverview />}
          />

          {/* ✅ AGENTIC AI CAREER TRACK ADDED */}
          <Route
            path="/job-readiness/agentic-ai-career-track"
            element={<AgenticAIOverview />}
          />

        </Routes>
      </LayoutWrapper>
    </Router>
  );
}